const modals = {
	AreYouSure: "Are you sure?",
	Yes: "Yes",
	No: "No"
};

export default modals;
